import { usePromoContext } from 'fitify-ui-onboarding/src/contexts/PromoContext'
import type { SubscriptionPageConfig } from 'fitify-ui-onboarding/src/types/subscription'

import {
  DEFAULT_PROMO_CODE,
  DOWNSELL_PROMO_CODE,
  GUESTPASS_PROMO_CODE,
  HSA_FSA_PROMO_CODE,
} from 'data/promo'
import { PromoDiscountPercentage } from 'sections/subscription/PromoImage/PromoDiscountPercentage'
import { StyledImage } from 'sections/subscription/PromoImage/PromoImage.Styled'
import { getImageProps } from 'utils/images'

type Props = {
  pageConfig: SubscriptionPageConfig
}

export const PromoImage = ({ pageConfig }: Props) => {
  const { promoCode } = usePromoContext()

  if (
    typeof promoCode !== 'string' ||
    promoCode === DEFAULT_PROMO_CODE ||
    promoCode === DOWNSELL_PROMO_CODE
  ) {
    return null
  }

  if (promoCode === HSA_FSA_PROMO_CODE) {
    return (
      <StyledImage
        alt="Subscription image"
        {...getImageProps('shared', 'subscription', 'flex')}
      />
    )
  }

  if (promoCode === GUESTPASS_PROMO_CODE) {
    return (
      <StyledImage
        alt="Subscription image"
        {...getImageProps('shared', 'subscription', 'promoReferralBlue')}
      />
    )
  }

  if (pageConfig.promoImageUrl) {
    return (
      <StyledImage
        alt="Subscription image"
        src={pageConfig.promoImageUrl}
        width={216}
        height={216}
      />
    )
  }

  if (pageConfig.promoDiscountPercentage) {
    return (
      <PromoDiscountPercentage
        discountPercentage={pageConfig.promoDiscountPercentage}
      />
    )
  }

  return (
    <StyledImage
      alt="Subscription image"
      {...getImageProps('shared', 'subscription', 'giftVoucher')}
    />
  )
}
